import React, {forwardRef} from "react";
import { ReactComponent as CalendarIcon } from '@/assets/icons/calendar-line.svg'
import Button from "@/components/common/Button";

interface ShowCalendarProps {
  value: string,
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

const ShowCalendar = forwardRef<any>((
  { value, onClick }: ShowCalendarProps,
  ref) => (
  <Button variant="basic"
          type="button"
          className="border border-grey-line-subtle gap-2"
          onClick={onClick} ref={ref}>
    <CalendarIcon />
    {value || 'Created Date'}
  </Button>))

export default ShowCalendar
